import {
    DetailedHTMLProps,
    ReactNode,
    TableHTMLAttributes,
    TdHTMLAttributes,
    ThHTMLAttributes,
} from "react";

type Props<T> = DetailedHTMLProps<TableHTMLAttributes<T>, T> & {
    children?: ReactNode;
    className?: string;
};

const TableBase = ({
    children,
    className,
    ...props
}: Props<HTMLTableElement>) => {
    return (
        <div className="block overflow-x-auto">
            <table className={`w-full ${className}`} {...props}>
                {/* <table className={`w-full ${className}`} {...props}> */}
                {children}
            </table>
        </div>
    );
};

const Head = ({
    children,
    className,
    ...props
}: Props<HTMLTableSectionElement>) => {
    return (
        <thead
            className={`border-b border-border-elevated ${className}`}
            {...props}
        >
            {children}
        </thead>
    );
};

const Body = ({
    children,
    className,
    ...props
}: Props<HTMLTableSectionElement>) => {
    return (
        <tbody className={`${className}`} {...props}>
            {children}
        </tbody>
    );
};

const Row = ({ children, className, ...props }: Props<HTMLTableRowElement>) => {
    return (
        <tr
            className={`border-b border-border-elevated ${className}`}
            {...props}
        >
            {children}
        </tr>
    );
};

const TH = ({
    children,
    className,
    ...props
}: DetailedHTMLProps<
    ThHTMLAttributes<HTMLTableCellElement>,
    HTMLTableCellElement
>) => {
    return (
        <th
            className={`py-3 text-base font-medium text-text-heading ${className}`}
            {...props}
        >
            {children}
        </th>
    );
};

const TD = ({
    children,
    className,
    ...props
}: DetailedHTMLProps<
    TdHTMLAttributes<HTMLTableCellElement>,
    HTMLTableCellElement
>) => {
    return (
        <td className={`h-14 px-3 text-text-heading ${className}`} {...props}>
            {/* ADD Border: <td className={`px-3 h-14 text-sm text-primary-text border border-primary-gray ${className}`} {...props}> */}
            {children}
        </td>
    );
};

const TableWithSubcomponenets = TableBase as typeof TableBase & {
    Head: typeof Head;
    Body: typeof Body;
    Row: typeof Row;
    TH: typeof TH;
    TD: typeof TD;
};
TableWithSubcomponenets.Head = Head;
TableWithSubcomponenets.Body = Body;
TableWithSubcomponenets.Row = Row;
TableWithSubcomponenets.TH = TH;
TableWithSubcomponenets.TD = TD;

export const Table = TableWithSubcomponenets;
